import React, { useContext } from "react"
import classnames from "classnames/bind"
import { close, isOpen, shadow, container, innerContainer } from "./modal.module.css"
import { X } from "react-feather"
import { ModalContext } from "src/context/ModalContext"

export const ModalLayout = ( { children } ) => {
  const cx = classnames.bind( { close, isOpen, container, innerContainer, shadow } )
  const { modalIsOpen, closeModal } = useContext( ModalContext )

  const handleClose = ( e ) => {
    if ( e.keyCode === 27 ) closeModal()
  }

  return (
    <>
      <div
        onClick={ closeModal }
        onKeyDown={ handleClose }
        role="button"
        aria-label="Close"
        tabIndex={ 0 }
        className={ cx( "shadow", { isOpen: modalIsOpen } ) }
      />
      <div className={ cx( "container", { isOpen: modalIsOpen } ) }>
        <div className={ close }>
          <X onClick={ closeModal } />
        </div>
        <div className={ innerContainer }>
          { children }
        </div>
      </div>
    </>
  )
}

export default ModalLayout
